import Highcharts from 'highcharts';
import ExportDataModule from 'highcharts/modules/export-data';
import ExportingModule from 'highcharts/modules/exporting';

if (typeof ExportingModule === 'function') {
  ExportingModule(Highcharts);
}

if (typeof ExportDataModule === 'function') {
  ExportDataModule(Highcharts);
}

export default Highcharts;
